import { css } from 'styled-components';
import { transition } from './animate';
import brand from './brand';
import { fluid } from './fluid';
import fonts from './fonts';
export const headingStyles = css `
  ${fonts.avenir.medium};
  color: currentColor;
  line-height: 1.2;
  letter-spacing: 0.2em;
  margin: 0 0 ${fluid(16, 24)};
  text-transform: uppercase;
`;
export const h1 = css `
  ${headingStyles};
  font-size: ${fluid(36, 48)};
`;
export const h2 = css `
  ${headingStyles};
  font-size: ${fluid(18, 24)};
`;
export const h3 = css `
  ${headingStyles};
  font-size: ${fluid(14, 18)};
`;
const paragraphStyles = css `
  ${fonts.avenir.regular};
  color: currentColor;
  letter-spacing: 0.032em;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 ${fluid(16, 24)};
`;
export const paragraphRegular = css `
  ${paragraphStyles};
`;
export const paragraphBold = css `
  ${paragraphStyles};
  ${fonts.avenir.semibold};
`;
export const paragraphThin = css `
  ${paragraphStyles};
  line-height: 1.2;
`;
export const paragraphThinBold = css `
  ${paragraphStyles};
  ${fonts.avenir.semibold};
  line-height: 1.2;
`;
export const paragraphLarge = css `
  ${paragraphStyles};
  font-size: ${fluid(14, 32)};
  line-height: ${fluid(22, 38)};
`;
export const label = css `
  ${paragraphThin};
`;
export const link = css `
  ${transition('text-decoration-color')};

  display: inline-block;
  text-decoration: underline;
  text-decoration-color: currentColor;
  text-decoration-thickness: 1px;
  text-underline-offset: 4px;

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    text-decoration-color: transparent;
  }
`;
export const blockquote = css `
  ${paragraphStyles};
  color: currentColor;
  padding-left: 28px;
  text-align: left;
  position: relative;

  &::before {
    content: '\\201C';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    font-size: 60px;
    line-height: 60px;
  }
`;
export const blockquoteName = css `
  ${paragraphBold};
  padding-left: 28px;
  text-align: left;

  > strong {
    display: block;
  }
`;
export const table = css `
  border-collapse: collapse;
  margin-bottom: 1em;
  width: 100%;

  thead {
    tr {
      td,
      th {
        ${h3};
        font-size: ${fluid(14, 14)};
        line-height: 1.5;
        background-color: ${brand.primary.beige};
        color: ${brand.black};
        padding: 12px 16px;
        text-align: left;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid ${brand.primary.beige};
      th {
        ${paragraphThinBold};
        padding: 12px 16px;
        text-align: left;
      }

      td {
        ${paragraphThin};
        padding: 12px 16px;
        text-align: left;
      }
    }
  }
`;
export const contentStyles = css `
  h1,
  .h1-styles {
    ${h1}
  }

  h2,
  .h2-styles {
    ${h2}
  }

  h3,
  .h3-styles {
    ${h3}
  }

  p {
    ${paragraphRegular}

    &.thin {
      ${paragraphThin}
    }

    &.center {
      text-align: center;
    }

    &.right {
      text-align: right;
    }

    strong {
      ${paragraphBold};

      &.thin {
        ${paragraphThinBold}
      }
    }

    a {
      ${link};
    }
  }

  a {
    ${link}
  }

  ol,
  ul {
    margin: ${fluid(8, 12)} 0 ${fluid(24, 32)};

    li {
      ${paragraphStyles};
      ${paragraphRegular}
      margin: 0;

      p {
        display: inline;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  ol {
    list-style: decimal;
    padding-left: 1.2em;
  }

  ul {
    list-style: disc;
    padding-left: 1.5em;
  }

  blockquote {
    ${blockquote};
  }

  .quote-name {
    ${blockquoteName}
  }

  hr {
    display: block;
    background: currentColor;
    border: 0;
    height: 2px;
    margin: ${fluid(32, 48)} 0;
    padding: 0;
    width: 100%;
  }

  table {
    ${table};
  }

  .responsive-table {
    position: relative;
    overflow-x: auto;
  }

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;
